import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRequest = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M18.3334 5.41667C18.3334 4.49619 17.5872 3.75 16.6667 3.75H15.0001C14.7826 3.75917 14.596 3.90768 14.5382 4.1175C14.3683 4.82035 13.7393 5.31548 13.0162 5.31546C12.2931 5.31545 11.6641 4.82029 11.4943 4.11744C11.4365 3.90765 11.2498 3.75917 11.0324 3.75H3.33341C2.41294 3.75 1.66675 4.49619 1.66675 5.41667V14.5833C1.66675 15.5038 2.41294 16.25 3.33341 16.25H11.0324C11.2498 16.2408 11.4365 16.0924 11.4943 15.8826C11.6641 15.1797 12.2931 14.6846 13.0162 14.6846C13.7393 14.6845 14.3683 15.1797 14.5382 15.8825C14.596 16.0923 14.7826 16.2408 15.0001 16.25H16.6667C17.5872 16.25 18.3334 15.5038 18.3334 14.5833V5.41667Z",
			stroke: "#748094",
			strokeWidth: 1.2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.9167 12.7083V12.2916",
			stroke: "#748094",
			strokeWidth: 1.2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.9167 10.2083V9.79165",
			stroke: "#748094",
			strokeWidth: 1.2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.9167 7.70831V7.29165",
			stroke: "#748094",
			strokeWidth: 1.2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgRequest;
